import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { companyIdState, editCompanyModalToggle } from "../../../../state/atom/settings";
import { Http } from "../../../../utility/http";
import { apiHeaders } from "../../../../utility/generic";
import { useState, useEffect } from "react";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { toaster } from "../../../../state/atom/toaster";
import * as Yup from 'yup';
import { Modal } from 'react-bootstrap';


type EditCompanyForm = {
  name: string;
}
export const EditCompanyModal = () => {
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useRecoilState(editCompanyModalToggle);
  const setToasterStatus = useSetRecoilState(toaster);
  const companyId = useRecoilValue(companyIdState);

  useEffect(() => {
    const getCompany = async () => {
      await Http.request(
        "get",
        `${process.env.REACT_APP_API_URL}company/${companyId}`,
        apiHeaders()
      )
        .then((res: any) => {
          // console.log(res);
          const company = res.data.company
          setValue("name", company.name);
        })
        .catch((error: any) => {
          console.error(error);
        });
    };
    getCompany();
  }, []);

  const editCompanyValidationSchema = Yup.object().shape({
    name: Yup.string().required("Company name is required."),
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<EditCompanyForm>({
    resolver: yupResolver(editCompanyValidationSchema),
  });

  const onSubmitHandler = async (data: EditCompanyForm) => {
    setLoading(true);
    await Http.request(
      "put",
      `${process.env.REACT_APP_API_URL}company/${companyId}`,
      data,
      apiHeaders()
    )
      .then((result: any) => {
        console.log(result.message);
        setToasterStatus({
          status: true,
          title: "Company Updated.",
          text: result.message,
        });
        setLoading(false);
        handleClose();
      })
      .catch((error: any) => {
        setSubmitErrorMessage(error.response.data.message);
        setLoading(false);
      });
  };

  
  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <>
    <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header
          className="panel-title"
          style={{ marginBottom: 0 }}
          closeButton
          closeVariant="white"
        >
          <Modal.Title className="text-white">Edit Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            {submitErrorMessage && (
              <div className="text-center py-1">
                <span className="text-danger">{submitErrorMessage}</span>
              </div>
            )}
            <form onSubmit={handleSubmit(onSubmitHandler)}>
              <div className="d-flex flex-column">
                <div className="form-group px-3 py-2">
                  <div style={{ color: "red" }}>
                    &#42;
                    <label
                      className="form-label"
                      htmlFor="inputStype"
                      style={{ color: "black" }}
                    >
                     Company Name
                    </label>
                  </div>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    id="stateName"
                    placeholder="Enter city"
                    {...register("name")}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>
              </div>
              <div className="form-group px-3 py-2">
                <button
                  type="submit"
                  className="btn bg-gradient-primary-login btn1 w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
